/**
 * EnergiPro IMS — System Footer
 * Displays consistently across all pages per Part 12 requirements.
 */
import { PRODUCT } from '../lib/productConfig';

export function ProductFooter() {
  return (
    <footer className="border-t border-gray-200 bg-white px-6 py-3 flex items-center justify-between text-xs text-gray-500">
      <div className="flex items-center gap-3">
        <span className="font-semibold text-gray-700">{PRODUCT.name}</span>
        <span className="text-gray-400">|</span>
        <span>{PRODUCT.edition} Edition</span>
        <span className="text-gray-400">|</span>
        <span>{PRODUCT.fullVersion}</span>
      </div>
      <div className="text-right">
        <span>{PRODUCT.copyright}. All Rights Reserved.</span>
      </div>
    </footer>
  );
}
